import './assets/search.css';

// Include only the reset
import 'instantsearch.css/themes/reset.css';
// or include the full Satellite theme
import 'instantsearch.css/themes/satellite.css';
// Include the autocomplete theme
import '@algolia/autocomplete-theme-classic/dist/theme.min.css';

import { loadHeaderSearch } from '@/Components/Navigation/header.search';
import { loadConditionLandingSearch } from '@/Features/Conditions/Landing/Components/client/condition-landing.search';
import { loadConditionSearch } from '@/Features/Conditions/Search/Components/client/condition.search';
import { loadHomePageSearch } from '@/Features/Home/Components/home-page.search';
import { loadLocationLandingSearch } from '@/Features/Locations/Landing/Components/client/location-landing.search';
import { loadLocationSearch } from '@/Features/Locations/Search/Components/client/location.search';
import { loadProviderLandingSearch } from '@/Features/Providers/Landing/Components/client/provider-landing.search';
import { loadProviderSearch } from '@/Features/Providers/Search/Components/client/provider.search';
import { loadSiteSearch } from '@/Features/SiteSearch/Components/client/site.search';

// global searches
loadHeaderSearch();
loadSiteSearch();
loadHomePageSearch();

// condition and treatment searches
loadConditionSearch();
loadConditionLandingSearch();

// provider searches
loadProviderSearch();
loadProviderLandingSearch();

// location searches
loadLocationSearch();
loadLocationLandingSearch();
